import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
/**
 * The one output size the picture is framed to. The prototype's media box is
 * 500x375 (a 4:3 column beside 542px of copy) under `object-fit: cover`, so the
 * slot's output is that box at 2x for a high-DPI screen.
 *
 * ONE target, like {@link HERO_MEDIA_CENTERED_TARGET}: the box keeps its 4:3
 * shape at every width — it only grows to the column's full width when the
 * layout stacks — so there is nothing to art-direct per screen.
 *
 * A stored reference names its framing BY SIZE, so this number is a contract:
 * changing it orphans every reference already stored.
 *
 * A VIDEO ignores this. It is served as uploaded — no rendition, no size floor —
 * and the box's 4:3 shape is imposed by CSS, so a clip of another shape is
 * covered into it and loses its edges. There is no framing step to choose which
 * edges, which is worth knowing when choosing a clip rather than a photograph.
 */
export const HERO_MEDIA_2_COLUMN_TARGET = {
    width: 1000,
    height: 750,
    aspectRatio: "4:3",
};
export const heroMedia2ColumnSchema = {
    componentId: "HeroMedia2Column",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Description",
            type: "textarea",
        },
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Hero media",
            // Either kind belongs in a page's opening: a photograph of a clinic and a
            // few seconds of one in use say the same thing at different speeds, and
            // this column is where a page makes its first impression.
            accepts: ["image", "video"],
            // Decoration, not something to watch. This opening carries no call to
            // action, so a player's controls would be the only thing on it asking to
            // be clicked — and the copy beside it is what the visitor came to read.
            // It loops silently, offers nothing to press, and is still for anyone who
            // asked for less motion.
            playback: "loop",
            targets: [{ ...HERO_MEDIA_2_COLUMN_TARGET }],
        },
    ],
};
//# sourceMappingURL=hero-media-2-column.js.map